import {BrokerageOfferService} from "./brokerage-offer/BrokerageOfferService";
import {IvConversionEventService} from "./google/IvConversionEventService";

export default angular.module("tfApp.services.iv", [])
                      .service(BrokerageOfferService.id, BrokerageOfferService)
                      .service(IvConversionEventService.id, IvConversionEventService)
    .name;
